/**
 * NewsList
 * @module components/NewsList
 */

import clsx from 'clsx';
import { useSiteType } from 'context/siteType.context';

interface NewsListModel {
	children: JSX.Element | JSX.Element[];
	borderTop: boolean;
}

const NewsList = ({ children, borderTop }: NewsListModel) => {
	const siteType = useSiteType();
	return (
		<ul
			className={clsx(
				'pt-3',
				borderTop &&
					(siteType === 'LindabGroup'
						? 'border-t border-solid  border-lgDarkGray'
						: 'border-t border-solid  border-greyDarker')
			)}
		>
			{children}
		</ul>
	);
};

export default NewsList;
